import { Box, Typography, AppBar } from '@mui/material';
import { styled } from '@mui/system';

interface RootDivProps {
  backgroundColor?: string;
}

export const RootDiv = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'backgroundColor',
})<RootDivProps>(({ theme, backgroundColor }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  zIndex: 100,
  top: 0,
  bottom: 'auto',
  height: '64px',
  padding: '0 24px',
  backgroundColor: backgroundColor || theme.palette.primary.dark,
  color: '#414046',
  boxShadow: '0px 1px 10px rgb(0 0 0 / 12%)',
}));

export const CenteredWrapper = styled(Box)({
  marginTop: '4px',
});

export const TitleTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '19px',
  lineHeight: '28.5px',
  letterSpacing: '0.15px',
  color: '#414046',
  textAlign: 'center',
});

export const LeftActionContainer = styled('div')({
  position: 'absolute',
  left: 24,
});
